export const PANES_INDICES = {
  'MANUAL_INVOICING': 0,
  'INTERNALS_ORDERS_INVOICING': 1,
};

export const panes = [
  {'menuItem': 'Facturación manual'},
  {'menuItem': 'Facturación de pedidos internos'},
];
